interface MonthNavHeaderProps {
  monthLabel: string
  onPrev: () => void
  onNext: () => void
  className: string
  navBtnClassName: string
}

export function MonthNavHeader({
  monthLabel,
  onPrev,
  onNext,
  className,
  navBtnClassName,
}: MonthNavHeaderProps) {
  return (
    <div className={className}>
      <button className={navBtnClassName} onClick={onPrev}>‹</button>
      <span>{monthLabel}</span>
      <button className={navBtnClassName} onClick={onNext}>›</button>
    </div>
  )
}
